import { ref, nextTick } from 'vue'

// Kapselt Sichtbarkeit + Positionierung des KalenderPopover, inkl. Teleport-Fix: der Kalender
// wird per <Teleport> an <body> gehängt und braucht deshalb seine Bildschirm-Position per JS.
//
// Zusätzlicher Fix: auf manchen externen Host-Seiten setzt irgendein Vorfahre im DOM
// (sticky header, off-canvas menu, slider-lib ...) transform/filter/will-change, was
// einen neuen containing block erzeugt. Dann verhält sich position:fixed relativ zu
// DIESEM Element statt zum Viewport, egal dass wir nach <body> teleportieren -
// der Kalender "springt" an eine falsche Stelle. Da wir das CSS der Host-Seite nicht
// kontrollieren können, korrigieren wir das selbst: nach dem Rendern messen wir die
// tatsächliche Position (getBoundingClientRect ist IMMER viewport-relativ, unabhängig
// vom Positionierungsschema) und rechnen die Differenz zur Soll-Position drauf.
export function useKalenderPopover() {
  const zeigeKalender = ref(false)
  const tagNavRef = ref(null)
  const kalenderElement = ref(null) // NEU: im Template per `ref="kalenderElement"` auf den Popover-Root binden
  const kalenderPositionStyle = ref({})

  async function kalenderUmschalten() {
    if (zeigeKalender.value) {
      zeigeKalender.value = false
      return
    }

    positioniereKalender()
    zeigeKalender.value = true

    await nextTick()
    korrigierePositionFallsVerschoben()
  }

  function positioniereKalender() {
    const rect = tagNavRef.value?.getBoundingClientRect()
    if (!rect) return
    const abstandOben = rect.bottom + 6
    const sicherheitsabstandUnten = 12
    const verfuegbareHoehe = window.innerHeight - abstandOben - sicherheitsabstandUnten

    kalenderPositionStyle.value = {
      top: `${abstandOben}px`,
      left: `${rect.left + rect.width / 2}px`,
      maxHeight: `${Math.max(verfuegbareHoehe, 240)}px`,
      overflowY: 'auto'
    }
  }

  function korrigierePositionFallsVerschoben() {
    const el = kalenderElement.value
    if (!el) return

    const sollTop = parseFloat(kalenderPositionStyle.value.top)
    const sollLeft = parseFloat(kalenderPositionStyle.value.left)
    if (Number.isNaN(sollTop) || Number.isNaN(sollLeft)) return

    const istRect = el.getBoundingClientRect()
    const halbeBreite = istRect.width / 2

    // Annahme: CSS zentriert das Element per transform: translateX(-50%) auf `left`.
    const deltaTop = sollTop - istRect.top
    const deltaLeft = sollLeft - (istRect.left + halbeBreite)

    // Nur korrigieren, wenn tatsächlich ein relevanter Versatz vorliegt (>1px Toleranz
    // für Rundungsfehler) - sonst fassen wir die Styles unnötig neu an.
    if (Math.abs(deltaTop) > 1 || Math.abs(deltaLeft) > 1) {
      kalenderPositionStyle.value = {
        ...kalenderPositionStyle.value,
        top: `${sollTop + deltaTop}px`,
        left: `${sollLeft + deltaLeft}px`
      }
    }
  }

  function kalenderSchliessen() {
    zeigeKalender.value = false
  }

  return {
    zeigeKalender,
    tagNavRef,
    kalenderElement,
    kalenderPositionStyle,
    kalenderUmschalten,
    kalenderSchliessen
  }
}